module.exports = __webpack_public_path__ + "media/images/category/feature/coj_d/logo-coj-en-3c9395d99f4ba83c1e870981f187bd62.svg";